import { _decorator, ccenum, Enum, SpriteFrame } from 'cc';
import { DEV, EDITOR } from 'cc/env';
import VapVideoMixComponent from './VapVideoMixComponent';
import { IVapData, VapSrcType } from '../Data/VapData';
import { setEnumAttr } from '../../../Utils/Utility';

const { ccclass, property } = _decorator;

enum DefaultVapSocketEnum {
    '<None>' = 0,
}
ccenum(DefaultVapSocketEnum);

@ccclass('VapSocket')
export default class VapSocket {
    @property
    private _type: VapSrcType = null;

    @property
    private _srcId: string = '';

    @property(VapVideoMixComponent)
    private _targetNode: VapVideoMixComponent = null;

    @property
    private _socketName: string = '';

    private _socketsEnums: any = Enum({});
    private _videoSpriteFrame: SpriteFrame = null;
    private _vapData: IVapData = null;

    @property({
        type: VapVideoMixComponent,
        displayName: DEV && '目標節點',
        tooltip: DEV && 'Vap合成動畫目標節點',
        visible(this: VapSocket) {
            return !!this._vapData;
        },
    })
    public get targetNode(): VapVideoMixComponent {
        return this._targetNode;
    }
    public set targetNode(value: VapVideoMixComponent) {
        this._targetNode = value;
        if (!this._targetNode) {
            return;
        }
        this._targetNode.setVapData(this._vapData, this._srcId);
        this._targetNode.bindVideoTexture(this._videoSpriteFrame);
    }

    @property({
        type: DefaultVapSocketEnum,
        displayName: DEV && '掛點名稱',
        tooltip: DEV && 'Vap合成動畫掛點名稱',
        visible(this: VapSocket) {
            return !!this._vapData;
        },
    })
    public get socketIndex() {
        const { _socketName: socketName } = this;
        if (socketName) {
            const { _socketsEnums: socketsEnums } = this;
            if (socketsEnums) {
                const animIndex = socketsEnums[socketName];
                if (animIndex !== undefined) {
                    return animIndex;
                }
            }
        } else {
            this._refreshInspector();
        }
        return 0;
    }
    public set socketIndex(value: number) {
        if (!this._vapData || !this._vapData.src) {
            return;
        }
        const socketName = value === 0 ? '' : this._socketsEnums[value];
        if (socketName !== undefined) {
            this._socketName = socketName;
            this._srcId = this._vapData.src.find((src) => src.srcTag === socketName)?.srcId;
            this._refreshInspector();
        }
    }

    public bindVideoTexture(spriteFrame: SpriteFrame) {
        this._videoSpriteFrame = spriteFrame;
        this.targetNode?.bindVideoTexture(spriteFrame);
    }

    public setVapData(data: IVapData) {
        if (data && data.src && data.src.length > 0) {
            this._vapData = data;
            this._type = this._vapData.src.find((src) => src.srcId === this._srcId)?.srcType;
            this.targetNode?.setVapData(this._vapData, this._srcId);
        } else {
            this._resetInEditor();
        }
        if (EDITOR) {
            this._refreshInspector();
        }
    }

    public setSocketDirectly(targetNode: VapVideoMixComponent, videoSpriteFrame: SpriteFrame, vapData: IVapData, srcId: string) {
        this.targetNode = targetNode;
        this._vapData = vapData;
        this._srcId = srcId;
        this._type = this._vapData.src.find((src) => src.srcId === this._srcId)?.srcType;
        this.bindVideoTexture(videoSpriteFrame);
        this.targetNode?.setVapData(this._vapData, this._srcId);
    }

    private _refreshInspector() {
        this._updateVapSocketEnums();
    }

    private _updateVapSocketEnums() {
        let newSocketsEnums = {};
        if (!this._vapData || !this._vapData.src) {
            newSocketsEnums = DefaultVapSocketEnum;
        } else {
            const enumDef: { [key: string]: number } = { '&lt;None&gt;': 0 };
            if (this._vapData?.src) {
                const srcTags = [...new Set(this._vapData.src.map((item) => item.srcTag).filter(Boolean))];
                srcTags.forEach((srcTag, index) => {
                    enumDef[srcTag] = index + 1;
                });
            }
            newSocketsEnums = Enum(enumDef);
        }
        this._socketsEnums = Enum({});
        Object.assign(this._socketsEnums, newSocketsEnums);
        Enum.update(this._socketsEnums);
        setEnumAttr(this, 'socketIndex', this._socketsEnums);
    }

    private _resetInEditor() {
        if (EDITOR) {
            this._type = null;
            this._srcId = '';
            this._socketName = '';
            this._vapData = null;
            this.targetNode = null;
            this._refreshInspector();
        }
    }
}
